<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <HeaderRegistered :return-path="returnPath" :should-go-back-in-route="returnPath" />
      <main class="main">
        <section class="dashboard-section">
          <div class="add-alias-bar">
            <button class="btn" @click="addAlias">
              Add Alias
            </button>
            <div v-if="aliases.length" class="holder-table">
              <table cellpadding="0" cellspacing="0" border="0">
                <thead class="table-header">
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Value</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="alias in aliases" :key="alias.content.id">
                    <td>
                      <button class="delete" @click="$refs.deleteAliasConfirmation.openPopup(alias)">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            data-v-1533b5dc=""
                            d="M11.9999 0.333328C5.54825 0.333328 0.333252 5.54833 0.333252 12C0.333252 18.4517 5.54825 23.6667 11.9999 23.6667C18.4516 23.6667 23.6666 18.4517 23.6666 12C23.6666 5.54833 18.4516 0.333328 11.9999 0.333328ZM17.8333 16.1883L16.1883 17.8333L11.9999 13.645L7.81159 17.8333L6.16659 16.1883L10.3549 12L6.16659 7.81166L7.81159 6.16666L11.9999 10.355L16.1883 6.16666L17.8333 7.81166L13.6449 12L17.8333 16.1883Z"
                          />
                        </svg>
                      </button>
                      <input
                        v-model="alias.content.name"
                        class="input-alias-name"
                        type="text"
                        placeholder="Enter Alias Name"
                        @input="aliasFieldUpdated($event, alias, 'name')"
                      >
                    </td>
                    <td>
                      <CustomSelect
                        v-model="alias.content.type"
                        :default="alias.content.type"
                        :options="alias.old ? [] : aliasTypes"
                        custom-class="select"
                        :class="{disabled: alias.old}"
                        @input="aliasFieldUpdated($event, alias, 'type')"
                      />
                    </td>
                    <td>
                      <CustomSelect
                        v-model="alias.content.value"
                        :default="alias.content.value"
                        :options="alias.values"
                        custom-class="select"
                        @input="aliasFieldUpdated($event, alias, 'value')"
                      />
                    </td>
                    <td>
                      <button
                        v-if="alias.old && alias.updated"
                        class="btn"
                        @click="updateAlias(alias)"
                      >
                        Update Alias
                      </button>
                      <button
                        v-else-if="!alias.old"
                        class="btn create-alias"
                        :disabled="!alias.content.name.length"
                        @click="createDeviceAlias(alias)"
                      >
                        Create Alias
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </main>
      <InfoDialog
        ref="deleteAliasConfirmation"
        title="Delete Alias"
        text="Are you sure you want to delete alias?"
        cancel-btn-text="Cancel"
        confirm-btn-text="Delete"
        @onConfirm="deleteAlias"
      />
      <CommonDialog ref="formSuccess">
        <svg
          width="94"
          height="94"
          viewBox="0 0 94 94"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M47.0015 0.776367C37.8596 0.776367 28.9231 3.48725 21.3218 8.56622C13.7206 13.6452 7.79623 20.8641 4.29777 29.3101C0.799324 37.7561 -0.11603 47.0499 1.66746 56.0161C3.45096 64.9823 7.8532 73.2183 14.3175 79.6826C20.7818 86.1469 29.0178 90.5492 37.984 92.3327C46.9503 94.1162 56.244 93.2008 64.69 89.7024C73.136 86.2039 80.355 80.2795 85.4339 72.6783C90.5129 65.0771 93.2238 56.1405 93.2238 46.9986C93.2238 34.7397 88.3539 22.9829 79.6856 14.3145C71.0172 5.6462 59.2604 0.776367 47.0015 0.776367V0.776367ZM77.1904 31.4853L39.2304 69.4164L16.8127 46.9986C16.0465 46.2324 15.616 45.1932 15.616 44.1097C15.616 43.0262 16.0465 41.987 16.8127 41.2208C17.5788 40.4546 18.618 40.0242 19.7015 40.0242C20.7851 40.0242 21.8242 40.4546 22.5904 41.2208L39.2882 57.9186L71.4704 25.7653C71.8498 25.3859 72.3002 25.0849 72.7959 24.8796C73.2915 24.6743 73.8228 24.5686 74.3593 24.5686C74.8958 24.5686 75.4271 24.6743 75.9228 24.8796C76.4184 25.0849 76.8688 25.3859 77.2482 25.7653C77.6276 26.1446 77.9285 26.595 78.1338 27.0907C78.3392 27.5864 78.4448 28.1176 78.4448 28.6541C78.4448 29.1907 78.3392 29.7219 78.1338 30.2176C77.9285 30.7133 77.6276 31.1637 77.2482 31.543L77.1904 31.4853Z"
            fill="#082655"
          />
        </svg>
        <h2 class="dialog-message-title">
          Success!
        </h2>
        <p class="dialog-message-description">
          You added new alias
        </p>
      </CommonDialog>
    </div>
    <AlertErrorMsg
      ref="errorAlert"
      :title="errorMessage"
      class="page-alert-error"
    />
  </div>
</template>
<script>
import HeaderRegistered from '../components/layout/HeaderRegistered';
import CustomSelect from '../components/inputs/CustomSelect';
import InfoDialog from '../components/popups/InfoDialog';
import CommonDialog from '../components/popups/CommonDialog';
import AlertErrorMsg from '../components/profile/AlertErrorMsg';

export default {
  name: 'ConfigureDevice',
  components: {
    AlertErrorMsg,
    CustomSelect,
    HeaderRegistered,
    InfoDialog,
    CommonDialog,
  },
  data() {
    return {
      errorMessage: '',
      returnPath: true,
      caseId: '',
      clientId: '',
      aliasesFromServer: [],
      aliases: [],
      aliasTypes: [{name: 'sim'}, {name: 'imei'}],
      sim: [],
      imei: [],
    };
  },
  async created() {
    this.caseId = this.$route.params.slug;
    this.clientId = this.$route.query.clientId;

    this.getImeiAndSimsList().then(this.getDeviceAliases);
  },
  methods: {
    byField(field) {
      return (a, b) => a[field] > b[field] ? 1 : -1;
    },
    getImeiAndSimsList() {
      return this.$load(async () => {
        await this.$api.cases.getSimsList(this.caseId, this.clientId).then(res => {
          this.sim = res.data.body.aliases;
        });
        await this.$api.cases.getImeiList(this.caseId, this.clientId).then(res => {
          this.imei = res.data.body.aliases;
        });
      });
    },
    getDeviceAliases() {
      this.$load(() => {
        this.$api.cases.getDeviceAliases(this.caseId, this.clientId).then(res => {
          this.aliasesFromServer = res.data.body;
          this.aliases = res.data.body.map(alias => ({
            content: JSON.parse(JSON.stringify(alias)),
            old: true,
            values: this.getAliasValues(alias.type),
            updated: false,
          }));
        })
          .catch(this.setErrorMessage);
      });
    },
    addAlias() {
      const values = this.getAliasValues('sim');
      this.aliases.push({
        content: {
          name: '',
          value: values[0].name,
          type: 'sim',
          id: Math.random().toString(16).slice(2),
        },
        old: false,
        values,
      });
    },
    createDeviceAlias(alias) {
      if (alias.content.value && alias.content.name) {
        this.$load(() => {
          this.$api.cases.createDeviceAlias(this.caseId, this.clientId, alias.content)
            .then((res) => {
              this.aliases.forEach((item, i) => {
                if (item.content.name === res.data.body.name && item.content.value === res.data.body.value) {
                  this.aliases[i].content.id = res.data.body.id;
                }
              });
              alias.old = true;
              this.$refs.formSuccess.openPopups();
              this.aliasesFromServer.push(JSON.parse(JSON.stringify(alias.content)));
            })
            .catch(this.setErrorMessage);
        });
      }
    },
    updateAlias(alias) {
      this.$load(() => {
        this.$api.cases.updateAlias(this.caseId, alias.content)
          .then(() => {
            this.aliasesFromServer = this.aliasesFromServer.map(aliasFromServer => {
              if (aliasFromServer.id === alias.content.id) {
                alias.updated = false;
                return JSON.parse(JSON.stringify(alias));
              }
              return aliasFromServer;
            });
            this.aliases = this.aliases.map(aliasState => {
              if (aliasState.id === alias.content.id) {
                alias.updated = false;
                return JSON.parse(JSON.stringify(alias));
              }
              return aliasState;
            });
          })
          .catch(this.setErrorMessage);
      });
    },
    deleteAlias(alias) {
      if (alias.old) {
        this.$load(() => {
          this.$api.cases.deleteDeviceAlias(this.caseId, alias.content.id, alias.content.type)
            .then(() => {
              this.aliases = this.aliases.filter(filterAlias => filterAlias.content.id !== alias.content.id);
            })
            .catch(this.setErrorMessage);
        });
      } else {
        this.aliases = this.aliases.filter(filterAlias => filterAlias.content.id !== alias.content.id);
      }
      this.$refs.deleteAliasConfirmation.closePopup();
    },
    getAliasValues(type) {
      return this[type] ? this[type].map(value => ({name: value})) : [];
    },
    aliasFieldUpdated(event, updatedAlias, contentField) {
      const alias = this.aliases.find(alias => alias.content.id === updatedAlias.content.id);
      if (updatedAlias.old) {
        const aliasFromServer = this.aliasesFromServer.find(alias => alias.id === updatedAlias.content.id);
        alias.updated = aliasFromServer[contentField] !== alias.content[contentField];
      }

      if (contentField === 'type') {
        alias.values = this.getAliasValues(event);
        alias.content.value = alias.values[0].name;
      }
    },
    setErrorMessage(err) {
      const {errors} = err.response.data;
      this.errorMessage = errors.message ? errors.message[0] : errors.name ? errors.name[0] : '';
      this.$refs.errorAlert.showAlert();
    }
  },
};
</script>
<style scoped>
.input-alias-name {
  width: 100%;
  border-radius: 79px;
  border: 1px solid var(--input-placeholder-value-color);
  padding: 12px 15px !important;
  font-size: 12px;
  transition: filter .3s;
}

.input-alias-name:hover {
  filter: drop-shadow(0px 0px 5px rgba(200, 205, 212, 0.5));
}

.input-alias-name::placeholder {
  color: var(--input-placeholder-value-color);
  font-size: 14px;
}

.holder-table {
  margin-top: 20px;
}

.table-header {
  background: var(--blue-bg-color);
}

th {
  padding: 20px 15px;
  text-align: left;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 10px;
}

td {
  height: 55px;
  padding: 15px 15px 0;
}

td:first-child {
  display: flex;
  align-items: center;
}

.delete {
  background: transparent;
  border: navajowhite;
}

.delete:hover svg {
  fill: var(--light-gray);
}

.delete svg {
  fill: var(--input-placeholder-value-color);
  transition: .3s all;
}

.disabled {
  pointer-events: none;
}
</style>
